import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionTitleText,
  AccordionTrigger,
} from "ui/gluestack/accordion";
import { ChevronDownIcon, ChevronUpIcon } from "ui/gluestack/icon";
import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { format } from "date-fns";
import { IdFullNameModel } from "app/services/api/types/common/models/IdFullNameModel";
import { useMemo } from "react";

interface Props {
  title: string;
  shiftHandoverId?: number;
  submittedAt: string | null;
  children: React.ReactNode;
  isSubmitted?: boolean;
  receivedBy?: IdFullNameModel | null;
}

export function ShiftAccordion({
  title,
  shiftHandoverId,
  children,
  submittedAt,
  isSubmitted,
  receivedBy,
}: Props) {
  const formattedDate = useMemo(() => {
    return submittedAt ? format(new Date(submittedAt), "MMMM do, h:mma") : "—";
  }, [submittedAt]);

  const fullName = useMemo(() => {
    if (!receivedBy) return "—";
    const { first_name: firstName, last_name: lastName } = receivedBy;
    return `${firstName ?? ""} ${lastName ?? ""}`.trim() || "—";
  }, [receivedBy]);

  return (
    <Accordion type="single" variant="filled" className="w-full">
      <AccordionItem
        key={shiftHandoverId}
        value={`${shiftHandoverId}`}
        className="border rounded-lg border-border-200 p-2 bg-white"
      >
        <AccordionHeader>
          <AccordionTrigger className="focus:web:rounded-lg">
            {({ isExpanded }) => (
              <>
                <View className="items-start gap-2">
                  <AccordionTitleText className="mr-1">
                    <Text>{title}</Text>
                  </AccordionTitleText>
                  {isSubmitted ? (
                    <View className="flex-row items-center">
                      <Text className="text-xs font-medium text-typography-600">
                        Signed by {fullName}
                      </Text>
                      <View className="bg-background-300 w-1.5 h-1.5 rounded-full mx-2" />
                      <Text className="text-xs font-medium text-typography-600">
                        {formattedDate}
                      </Text>
                    </View>
                  ) : null}
                </View>
                {isExpanded ? (
                  <AccordionIcon as={ChevronUpIcon} />
                ) : (
                  <AccordionIcon as={ChevronDownIcon} />
                )}
              </>
            )}
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
